import React from "react";
import { observer } from "mobx-react";
import { L10n } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import commonStyles from "../../../containers/settings/settingsEditCommon.css";
import { AgentAvatarSettingsDropZone } from "./components/agentAvatarSettingsDropZone";
import { SubtitleDescription } from "../subtitleDescription";
import { SettingsForm } from "../settingsForm";
import { withPermissionFallback } from "../../HOC/withPermissionFallback/withPermissionFallback";
import { useAgentAvatarSettings } from "./useAgentAvatarSettings";
import { AppPermission } from "@closerplatform/spinner-openapi";

export const AgentAvatarSettingsComponent = observer(() => {
  const { avatarForm, isAvatarFormEdited, resetAvatarForm, submitAvatarForm } =
    useAgentAvatarSettings();

  const renderHeading = () => {
    return (
      <div className={commonStyles.title}>
        <L10n id="settings.advisers" />
      </div>
    );
  };

  const renderAvatarForm = () => {
    return (
      <div className={commonStyles.section}>
        <SubtitleDescription
          subtitle={intl.formatMessage("settings.adviserAvatar.title")}
          description={intl.formatMessage("settings.adviserAvatar.description")}
        />
        <div className={commonStyles.content}>
          <AgentAvatarSettingsDropZone
            image={avatarForm.value}
            onLoad={avatarForm.set}
            onDelete={() => avatarForm.set({ file: undefined, url: undefined })}
          />
        </div>
      </div>
    );
  };

  return (
    <SettingsForm
      disabled={!isAvatarFormEdited}
      onDiscard={resetAvatarForm}
      onSubmit={submitAvatarForm}
    >
      {renderHeading()}
      {renderAvatarForm()}
    </SettingsForm>
  );
});

export const AgentAvatarSettings = withPermissionFallback<{}>(
  AppPermission.SettingsAdvisersAvatar,
  AgentAvatarSettingsComponent
);
